<template>
  <label class="app-switch" :class="switchClasses">
    <input
      type="checkbox"
      class="app-switch__input"
      :checked="currentValue"
      :disabled="disabled"
      :name="name"
      @change="onChange"
    />
    <span class="app-switch__track" :style="trackStyle">
      <span class="app-switch__thumb" />
    </span>
    <span v-if="label || $slots.default" class="app-switch__label">
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>

<script>
import { VARIANT_COLORS } from './variants.js'

export default {
  name: 'AppSwitch',
  inheritAttrs: false,
  props: {
    modelValue: { type: Boolean, default: undefined },
    value: { type: Boolean, default: undefined },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    name: { type: String, default: '' },
    variant: { type: String, default: 'secondary' }
  },
  emits: ['update:modelValue', 'input'],
  computed: {
    currentValue() {
      return this.modelValue !== undefined ? this.modelValue : this.value
    },
    switchClasses() {
      return {
        'app-switch--disabled': this.disabled
      }
    },
    trackStyle() {
      const c = VARIANT_COLORS[this.variant] || VARIANT_COLORS.primary
      return this.currentValue
        ? { backgroundColor: c.bg, borderColor: c.border }
        : {}
    }
  },
  methods: {
    onChange(event) {
      this.$emit('input', event.target.checked)
      this.$emit('update:modelValue', event.target.checked)
    }
  }
}
</script>

<style scoped>
.app-switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}
.app-switch--disabled { opacity: 0.6; cursor: not-allowed; }

.app-switch__input { position: absolute; opacity: 0; width: 0; height: 0; }

.app-switch__track {
  width: 40px;
  height: 22px;
  background: #ced4da;
  border: 1px solid #adb5bd;
  border-radius: 11px;
  position: relative;
  flex-shrink: 0;
  transition: all 0.2s ease;
}
.app-switch__thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}
.app-switch__input:checked + .app-switch__track .app-switch__thumb {
  transform: translateX(18px);
}
.app-switch__input:focus-visible + .app-switch__track {
  box-shadow: 0 0 0 0.2rem rgba(0,123,255,0.2);
}
</style>
